import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Grid, Button, Paper, Typography } from "@mui/material";

import NotificationsTable from "../resource/table/NotificationsTable";
import { mappedLabelToStatus } from "../resource/tabs/tabs.header";
import FilterBar from "../resource/filter/FilterBar";
import StatusTabs from "../resource/tabs/StatusTabs";

import { useNotification } from "../context";

import ROUTES from "@config/routes";

const ListNotifications: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const {
    actions: { search },
    currentTab,
    setTab,
  } = useNotification();

  const handleSearchWithTabParams = (tabUrlParameter?: string | null) => {
    if (tabUrlParameter) {
      const tabUrl = mappedLabelToStatus[tabUrlParameter];
      if (tabUrl) {
        return setTab(tabUrl);
      }
    }
  };

  const handleCreate = () => {
    history.push(`${ROUTES.ADMIN_ROUTES.NOTIFICATIONS.CREATE}`);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");

    // NOTE: leitura ?tab= da URL para aplicar logica de redirecionamento
    void handleSearchWithTabParams(tabParam);

    // Note: Busca inicial padrao sem parametro na URL

    if (!tabParam) void search({ retrieveUsers: true });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <Grid
      container
      spacing={3}
      sx={{
        mt: 0.8,
        mr: 0,
        p: { xs: 0.8, md: "0px 12px 0px 42px", lg: "0px 12px 0px 32px" },
      }}
    >
      <Grid item sx={{ ml: 0 }}>
        <Typography variant="h3" sx={{ fontWeight: 700 }}>
          Notificações
        </Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper style={{ padding: 24 }}>
            <Typography
              variant="h5"
              style={{ marginBottom: 16, fontWeight: 600 }}
            >
              Informe os parâmetros para filtrar
            </Typography>
            <FilterBar />
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Grid item>
            <StatusTabs />
          </Grid>

          <Grid item sx={{ display: "flex", gap: 3, px: 0 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleCreate}
              size={"large"}
            >
              Criar notificação
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <NotificationsTable currentTab={currentTab} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ListNotifications;
